
import { tzFetch, HOST} from "../../../utils/http";

//send OTP
export function getReceipt(params = {}) {
  return tzFetch(`${HOST}/fapi/v1/transfer/view-receipt?id=`+ params, 'GET');
}